// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".load-more-entry{padding:10px;text-align:center}", "",{"version":3,"sources":["webpack://./src/app/components/Chat/MessageHistory/LoadMoreEntry/LoadMoreEntry.css"],"names":[],"mappings":"AAAA,iBAEE,YAAa,CADb,iBAEF","sourcesContent":[".load-more-entry {\n  text-align: center;\n  padding: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
